export const MANY_CLASSES_LABEL_TEXT = 'Classes Created'
export const REPORT_SITE_PATH = '/reports/k8?site='
export const SINGLE_CLASS_LABEL_TEXT = 'Class Created'
